import { SelectionPanel } from '$tablet-app/src/app/components/SelectionPanel';
import { MealType } from '@akin-home/amplify';
import { toggleInList } from '@akin-home/arrays';
import { Text } from '@akin-home/text/native';
import styled from 'styled-components/native';
import { useMealPreferenceDialogState } from '../../store/useMealPreferenceDialogState';
import { MEAL_TYPES } from '../MealsToPlanView';

export const MealRemindersView = () => {
  const reminders = useMealPreferenceDialogState(
    (state) => state.draft_preferences.reminders
  );

  const update = useMealPreferenceDialogState(
    (state) => state.updatePreference
  );

  const onPressMeal = (meal_type: MealType) =>
    update({ reminders: toggleInList(reminders, meal_type) });

  return (
    <Container>
      <Text weight="semibold">
        Select the meals you would like to get reminders (Optional)
      </Text>

      <Row>
        {MEAL_TYPES.map((meal) => (
          <SelectionPanel
            key={meal.value}
            onPress={onPressMeal}
            selected={reminders?.includes(meal.value)}
            {...meal}
          />
        ))}
      </Row>
    </Container>
  );
};

const Container = styled.View`
  gap: 30px;
  padding: 30px;
  padding-top: 0;
  align-items: center;
`;

const Row = styled.View`
  flex-direction: row;
  gap: 30px;
`;
